import retrieveBlacklists from 'app/modules/lists/sagas/retrieveBlacklists';
import createBlacklist from 'app/modules/lists/sagas/createBlacklist';

const sagaRegistry = [retrieveBlacklists, createBlacklist];

export default sagaRegistry;
